import { Application } from "pixi.js"

export const createPixiApp = (ref, app) => {
  if (!(ref.current?.children.length < 1 && !app)) return

  const newApp = new Application({
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: 0x160e28,
    resolution: 1,
    antialias: false,
  })

  appendView(ref, newApp)
  return newApp
}

const appendView = (ref, app) => {
  if (!(ref.current?.children.length === 0 && app)) return
  ref.current.appendChild(app.view)
}
